export default __webpack_public_path__ + "static/media/new_05.1450cb22.jpg";